import {BookingModuleBookingExperts} from "./bookingexperts";
import {BookingModuleEveryOffice} from "./everyoffice";
import {BookingModuleStratech} from "./stratech";
import {BookingModuleTommy} from "./tommy";
import {BookingModuleVB} from "./vb";
import {BookingModuleGlobal} from "./global";
import {raf} from "../util";

export function registerBookingModules() {
    const modules = {
        global: {
            accommodations: BookingModuleGlobal
        },
        bookingexperts: {
            accommodation_availability: BookingModuleBookingExperts
        },
        everyoffice: {
            accommodation_availability: BookingModuleEveryOffice
        },
        stratech: {
            accommodation_availability: BookingModuleStratech
        },
        tommy: {
            accommodation_availability: BookingModuleTommy
        },
        vb: {
            accommodation_availability: BookingModuleVB
        }
    };

    raf(() => {
        const els = Array.prototype.slice.call(document.querySelectorAll("[data-booking-module][data-booking-view]"));

        els.forEach(el => {
            const module = el.dataset.bookingModule;
            const view = el.dataset.bookingView;

            const views = modules[module];

            if (typeof views === "undefined")
                return;

            const cls = views[view];

            if (typeof cls === "undefined")
                return;

            new cls(el);
        });
    });
}
